import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight, UtensilsCrossed, Users, Heart, Coins } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';

const slides = [
  {
    icon: UtensilsCrossed,
    title: 'Compartilhe refeições',
    description: 'Conecte-se com pessoas da sua comunidade através da comida caseira. Cozinhe para outros ou desfrute de refeições preparadas com carinho.',
  },
  {
    icon: Users,
    title: 'Fortaleça sua comunidade',
    description: 'Conheça vizinhos, faça amigos e crie laços genuínos ao redor da mesa. A comida une pessoas.',
  },
  {
    icon: Heart,
    title: 'Economia justa',
    description: 'Sem exploração. Nossa taxa máxima é de 10%, garantindo que cozinheiros e convidados tenham uma experiência justa.',
  },
  {
    icon: Coins,
    title: 'Ganhe tokens',
    description: 'A cada refeição compartilhada, você acumula tokens Rango. Quanto mais você participa, mais você ganha com a plataforma.',
  },
];

export function WelcomePage() {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const handleNext = () => {
    if (currentSlide < slides.length - 1) {
      setCurrentSlide(currentSlide + 1);
    } else {
      navigate('/cadastro');
    }
  };
  
  const handleSkip = () => {
    navigate('/cadastro');
  };
  
  const CurrentIcon = slides[currentSlide].icon;
  
  return (
    <div className="w-full max-w-md">
      <Card className="border-0 bg-white/80 shadow-xl backdrop-blur">
        <CardContent className="p-8">
          {/* Slide content */}
          <div className="mb-8 text-center">
            <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-2xl bg-gradient-to-br from-rango-400 to-rango-600 text-white shadow-lg shadow-rango-500/30">
              <CurrentIcon className="h-10 w-10" />
            </div>
            
            <h2 className="mb-3 font-display text-2xl font-bold text-foreground">
              {slides[currentSlide].title}
            </h2>
            
            <p className="text-muted-foreground">
              {slides[currentSlide].description}
            </p>
          </div>
          
          {/* Dots indicator */}
          <div className="mb-8 flex justify-center gap-2">
            {slides.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={cn(
                  'h-2 rounded-full transition-all',
                  index === currentSlide
                    ? 'w-8 bg-primary'
                    : 'w-2 bg-muted-foreground/30 hover:bg-muted-foreground/50'
                )}
              />
            ))}
          </div>
          
          {/* Actions */}
          <div className="space-y-3">
            <Button
              onClick={handleNext}
              className="w-full"
              size="lg"
            >
              {currentSlide < slides.length - 1 ? 'Próximo' : 'Começar'}
              <ChevronRight className="h-4 w-4" />
            </Button>
            
            {currentSlide < slides.length - 1 && (
              <Button
                onClick={handleSkip}
                variant="ghost"
                className="w-full"
              >
                Pular introdução
              </Button>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

